import { render } from "./GlobalTransactionEnterpriseEuropeView.vue?vue&type=template&id=65ffd6da"
import script from "./GlobalTransactionEnterpriseEuropeView.vue?vue&type=script&lang=js"
export * from "./GlobalTransactionEnterpriseEuropeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__